import { useEffect, useRef, useState } from 'react';
import useUserStore from 'store/user';

const useIncrementNumber = () => {
  // store
  const { point, increasePoint } = useUserStore();

  // state
  const [isAnimating, setIsAnimating] = useState(false);
  const targetRef = useRef<number>(0);
  const animationRef = useRef<number | null>(null);

  // method
  const startAnimation = (addPoint: number = 100) => {
    if (!isAnimating) {
      targetRef.current = point + addPoint; // 현재 point + 100을 목표로 설정
      setIsAnimating(true);
    }
  };

  useEffect(() => {
    let startTime: number;
    const animate = (time: number) => {
      if (!startTime) startTime = time;
      const progress = time - startTime;

      if (progress >= 30) {
        if (point < targetRef.current) {
          increasePoint();
          startTime = time;
        } else {
          setIsAnimating(false);
          return;
        }
      }

      if (isAnimating) {
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    if (isAnimating) {
      animationRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isAnimating, point, increasePoint]);

  return { startAnimation, isAnimating };
};

export default useIncrementNumber;
